import React, { useEffect, useCallback, useState } from 'react'
import { useSelector } from 'react-redux'
import { CircularProgress } from '@mui/material'
import * as Sentry from '@sentry/browser'
import { get, post, URL_VARIABLES } from 'services/api'
import { verifyTokenRole } from 'config/tokenRouter'
import validateStageOnboarding from 'utils/validateStage'
import { AnimatedCheck } from 'components/Antifraude'
import { roles } from 'utils/constants/roles'
import Colors from 'utils/Colors'

import { PreviewContainer } from './styles'

export default (props) => {
  const { history, location } = props
  const { token } = useSelector((state) => state.token)
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(false)
  const [loadingMessage, setLoadingMessage] = useState(null)
  const [showWaitMessage, setShowWaitMessage] = useState(false)

  const { title, file, type } = location.state

  const previewImage = useCallback(() => {
    const img = document.getElementById('preview')
    img.file = file
    const reader = new FileReader()
    reader.onload = ((aImg) => {
      const bImg = aImg
      return (e) => {
        bImg.src = e.target.result
      }
    })(img)
    reader.readAsDataURL(file)
  }, [file])

  const handleLoading = (newState) => {
    setLoading(newState)
  }

  useEffect(() => {
    validateStageOnboarding(token, history, roles.DOCUMENT_OCR, handleLoading)
  }, [])

  useEffect(() => {
    previewImage()
  }, [previewImage])

  function chooseOption() {
    history.replace({
      pathname: '/ocr-upload',
      state: { type: type },
    })
  }

  // function handleGoBack() {
  //   history.goBack()
  // }

  function sizeOf(base64) {
    try {
      const base64str = base64.split('base64,')[1]
      const decoded = atob(base64str)
      return decoded.length
    } catch {
      return -1
    }
  }

  function handleResponseError(file_base64) {
    Sentry.captureException(
      new Error('Erro ao enviar documento'),
      scope => {
        scope.clear()
        scope.setTag('step', 'ocr-upload')
        scope.setContext('context', {
          'info': file_base64 && file_base64.substr(0, 30),
          'bytes': sizeOf(file_base64),
        })
        return scope
      })

    history.replace({
      pathname: '/ocr-fail',
      state: { type, error: 'Erro ao enviar documento' },
    })
  }

  async function callDocumentValidation() {
    setShowWaitMessage(false)
    setLoadingMessage('Validando dados')

    const { data } = await get({
      url: '/onboarding/ocr/validation',
      token,
      source: URL_VARIABLES.ANTIFRAUDE,
    })

    if (data) {
      const { token: userToken, success: successState } = data

      setSuccess(successState)
      setLoadingMessage(null)
      verifyTokenRole(userToken, history, null)
    }
  }

  async function handleSubmit(file_base64) {
    setLoading(true)
    setLoadingMessage('Lendo informações do documento...')
    setShowWaitMessage(true)

    let data
    let status

    try {
      const response = await post({
        url: `/onboarding/ocr`,
        token,
        data: { base64: file_base64, type },
        source: URL_VARIABLES.ANTIFRAUDE,
      })

      data = response.data
      status = response.status
    } catch (error) {
      const response = error.response ?? {}

      data = response.data ?? {}
      status = response.status ?? 400
    }

    const ocrApproved = status === 200
    const requiresNextOcrStep = status === 201

    if (ocrApproved) {
      callDocumentValidation()
    } else if (requiresNextOcrStep) {
      verifyTokenRole(data.token, history, null)
    } else if (!data.token) {
      handleResponseError(file_base64)
    } else {
      verifyTokenRole(data.token, history, null)
    }
  }

  const getBase64 = (fileEntry, cb) => {
    const reader = new FileReader()
    reader.readAsDataURL(fileEntry)
    reader.onload = () => {
      const { result } = reader
      cb(result)
    }
    reader.onerror = (error) => {
      console.error(error)
      return null
    }
  }

  return (
    <PreviewContainer
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      <p className='title'>{title}</p>
      <img id='preview' className='image' alt='' />
      <p className='question'>O texto da imagem está bem legível?</p>

      <div className='buttons_container'>
        <button type='button' className='no_button' onClick={chooseOption}>
          Não
        </button>
        <button type='button' className='yes_button' onClick={() => {
          getBase64(file, handleSubmit)
        }}>
          Sim
        </button>
      </div>

      {loading && (
        <React.Fragment>
          <div className='loading'>
            <div className='loading__container'>
              {!showWaitMessage ? !success ? <CircularProgress /> : <AnimatedCheck /> : null}
            </div>
          </div>
          {(loading && loadingMessage) &&
            <div className='loading_text'>
              <div className='loading_text__container'>
                <p>{loadingMessage}</p>
                {showWaitMessage && <CircularProgress />}
                {showWaitMessage && <p id='orange_text'><br />Por favor, aguarde. <br /><br /><b
                  style={{ color: Colors.primaryColor }}> Este processo pode levar até 60 segundos.</b></p>}
              </div>
            </div>
          }
        </React.Fragment>
      )}
    </PreviewContainer>
  )
}
